import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { ClickDeleteModule } from '@web-frontend/shared/directives/click-delete';
import { ModalTemplateModule } from '../../modal-template';
import { ShowDetailClockHourComponent } from './show-detail-clock-hours.component';
import { DateDayMonthModule } from '@web-frontend/shared/pipes/date-day-month/date-day-month.module';
import { AddClockHourModule } from '../../add-clock-hour';
import { TranslateModule } from '@ngx-translate/core';
import { PermissionsModule } from '../../permissions';
import { BaseButtonModule } from '@web-frontend/common/components/button/baseButton.module';
import { UserAvatarModule } from '../../user-avatar/user-avatar.module';
import { MatIconModule } from '@angular/material/icon';
import { LoadingModule } from '../../loading/loading.module';
import { GoogleMapsLinkModule } from '../../google-maps-link/google-maps-link.module';

@NgModule({
  declarations: [ShowDetailClockHourComponent],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    ModalTemplateModule,
    MatButtonModule,
    ClickDeleteModule,
    DateDayMonthModule,
    AddClockHourModule,
    PermissionsModule,
    BaseButtonModule,
    UserAvatarModule,
    MatIconModule,
    LoadingModule,
    GoogleMapsLinkModule,
  ],
  exports: [ShowDetailClockHourComponent],
})
export class ShowDetailClockHourModule {}
